import React, { useState, useContext } from 'react';
import {
  SafeAreaView,
  StyleSheet,
  View,
  Text,
  TextInput,
  Button,
  Image,
  Alert,
  TouchableOpacity,
} from 'react-native';
import { AuthContext } from '../Contexts/ContextUsuario';
import firebase from 'firebase';

// Inicializar o Firebase
var app = firebase.app();

var db = app.database();
var auth = app.auth();


var valor;


const TelaCadastro = (props) => {
  const [userName, setUserName] = React.useState('');
  const [userPassoword, setUserPassoword] = useState('');
  const [confirmPassoword, setConfirmPassoword] = useState('');
  const { state, actions } = useContext(AuthContext);
  
  function handleLogin(){
    console.log('handleLogin!')

    // try {
      // db.ref('usuarios/' + userName).once('value').then(async (snapshot) => { 
      //   valor = await snapshot.val();

        if(userPassoword != confirmPassoword){
          alert('As senhas não coincidem.')
        }else{
          auth.createUserWithEmailAndPassword(userName + "@maristavirtual.org.br", userPassoword).then(() => {
            alert('Usuário cadastrado com sucesso!')
            
            db.ref('usuarios/' + userName).set({
            matricula: userName,
            saldo: 0,
            N_pedido: 0
          })
            props.navigation.navigate('LOGIN')
          }).catch((err) => {console.log(err)
            if(err.code == "auth/weak-password"){
              alert('Senha fraca', 'Sua senha deve ter no mínimo 6 caracteres.')
            }
            else if(err.code == "auth/email-already-exists"){
              alert('Email já cadastrado', 'Tente outro endereço ou vá para a página de login.')
            }
            else if(err.code == "auth/internal-error"){
              alert('Erro interno', 'Tente novamente mais tarde.')
            }
            else if(err.code == "auth/invalid-email"){
              alert('O endereço do email é inválido', 'Verifique se não há nenhum erro de digitação.')
            }
            else if(err.code == "auth/maximum-user-count-exceeded"){
              alert('Erro no servidor', 'Por favor contate o suporte.')
            }
            else if(err.code == "auth/operation-not-allowed"){
              alert('É possível que o servidor esteja passando por atualizações', 'Por favor contate o suporte.')
            }
            else if(err.code == "auth/project-not-found "){
              alert('É possível que o servidor esteja passando por atualizações', 'Por favor contate o suporte.')
            }
            else {
              alert('Ocorreu um erro:', `${err.message}\nCódigo de erro: ${err.code}`)
            }
          })
          
          
          
        } 

      // })
  //   } catch (e) {
  //   console.log(e);
  //   Alert.alert('Ocorreu um erro, tente novamente')
  // }
}

const handleVoltarLogin = () => {
  props.navigation.navigate('LOGIN')
}

  return (
    <View style={Style.container}>

      <View style={Style.LogoSpace}>
        <Image
          style={Style.CantinaSantaClara}
          source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/809404531241779240/logoCantina.png'}}
        />
      </View>

      <View style={Style.LoginSpace}>
        
        <View style={Style.TypingSpace}>

          <Text style={Style.LoginText}>
            CADASTRO
          </Text>
        

          <View style={Style.TypingLayout}>
            <Image
              style={Style.Icon}
              source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/804330284513492992/IconePerfil.PNG'}}
            />

            <TextInput
              keyboardType={'default'}
              onChangeText={username => setUserName(username)}
              value={userName}
              placeholder={'Nº de matrícula'}
              style={Style.InputText}
            />
          </View>

          <View style={Style.TypingLayout}>
            <Image
                style={Style.Icon}
                source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/811744999451787274/passwordIcon.PNG'}}
              />
            <TextInput
              secureTextEntry={true}
              value={userPassoword}
              onChangeText={(userpassoword) => setUserPassoword(userpassoword)}
              placeholder={'Senha'}
              style={Style.InputText}
            />
          </View>

          <View style={Style.TypingLayout}>
            <Image
                style={Style.Icon}
                source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/811750313388015666/passwordConfirmicon.PNG'}}
              />
            <TextInput
              secureTextEntry={true}
              value={confirmPassoword}
              onChangeText={(confirmpassoword) => setConfirmPassoword(confirmpassoword)}
              placeholder={'Confirme sua senha'}
              style={Style.InputText}
            />
          </View>
        
          <TouchableOpacity
            style={Style.ButtonLogin}
            onPress={handleLogin}>
            <Text style={Style.ButtonLoginText}> Cadastro </Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={Style.ButtonRegister}
            onPress={handleVoltarLogin}>

            <Text style={Style.ButtonRegisterText}> Voltar à página de login </Text>
          </TouchableOpacity>

        </View>
      </View>
    </View>
    );
}

const Style = StyleSheet.create({
  container: {
    flexDirection: 'column',

    width: '100%',
    height: '100%',

    backgroundColor: 'rgba(179, 179, 179, 255)',
  },

  LogoSpace:{
    flexDirection: 'row',
    justifyContent: 'center',

    marginTop: '5%',
  },

  LoginSpace: {
    flexDirection: 'row',
    justifyContent: 'center',

    width: '100%',
    height: '100%',
  },

  TypingSpace: {
    justifyContent: 'center',
    alignItems: 'center',

    width: '85%',
    height: 400,

    marginTop: '5%',

    borderRadius: 20,

    backgroundColor: 'rgba(112, 112, 112, 255)',
  },

  LoginText: {
    fontFamily: 'Segoe UI',
    fontSize: 18,

    color: 'rgba(255, 255, 255, 255)',
  },

  InputText: {
    marginStart: 15,

    fontFamily: 'Segoe UI',
    fontSize: 13,
  },

  CantinaSantaClara: {
    height: 160,
    width: 260,

    marginTop: 30,
  },

  ButtonLogin: {
    justifyContent: 'center',

    width: '80%',
    height: '15%',

    marginTop: 25,
    borderRadius: 20,
    
    backgroundColor: 'rgba(0, 58, 109, 255)',

  },

  ButtonLoginText: {
    textAlign: 'center',

    fontFamily: 'Segoe UI',
    fontSize: 17,

    color: 'rgba(255, 255, 255, 255)',
  },

  ButtonRegisterText: {
    textAlign: 'center',

    fontFamily: 'Segoe UI',
    fontSize: 13,

    color: 'rgba(255, 255, 255, 255)',
  },

  ButtonRegister: {
    marginTop: 15,
  },

  TypingLayout: {
    flexDirection: 'row',
    alignItems: 'center',

    width: '95%',
    height: '13%',

    marginTop: 17,
    borderRadius: 20,

    backgroundColor: 'rgba(255, 255, 255, 255)',
  },

  Icon: {
    height: 25,
    width: 25,

    marginStart: 15,
  },
  });
  

export default TelaCadastro;